export default function bulkArchiveGeneratedReportInstanceDirective() {
  return {
    template: require('./bulk-archive-generated-report-instance.html'),
    restrict: 'E',
    controller: 'BulkArchiveGeneratedReportInstanceController',
    controllerAs: 'bulkArchiveGeneratedReportInstanceVM',
    bindToController: true,
    replace: true,
    scope: {
      reportInstance: '=',
    },
  };
}
